import AliPayForm from './ali-pay-form.vue';

export default AliPayForm;